// src/pages/KakaoCallback.tsx
import { useEffect } from 'react';

const KakaoCallback = () => {
    useEffect(() => {
        const handleCallback = () => {
            const code = new URLSearchParams(window.location.search).get('code');
            const state = new URLSearchParams(window.location.search).get('state');

            if (code && window.opener) {
                // 부모 창으로 인증 코드 전달
                window.opener.postMessage({
                    type: 'KAKAO_LOGIN_SUCCESS',
                    code,
                    state
                }, window.location.origin);

                // 팝업 창 닫기
                window.close();
            }
        };

        handleCallback();
    }, []);

    return null;
};

export default KakaoCallback;